import { UndoManager } from './UndoManager';

export const undoManager = new UndoManager();
export const $undoDesc = undoManager.undoDesc;
export const $redoDesc = undoManager.redoDesc;
